// Небольшое колдунство, которое поможжет получить честную высоту страницы на мобильных
const setVH = () => {
  // let vh = window.innerHeight * 0.01;
  // document.documentElement.style.setProperty('--vh', `${vh}px`);
  // document.documentElement.style.setProperty('height', `${window.innerHeight}px`);
  document.documentElement.style.setProperty('--vh100', `${window.innerHeight}px`)
}
window.addEventListener('resize', setVH)
setVH()
